import * as braze from "@braze/web-sdk";

export type BrazeBannerPlacement = "dashboard-top";

export const BrazeService = {
  initialize(userId: string): void {
    braze.initialize(process.env.REACT_APP_BRAZE_API_KEY as string, {
      baseUrl: process.env.REACT_APP_BRAZE_BASE_URL as string,
      allowUserSuppliedJavascript: true,
      doNotLoadFontAwesome: true,
      minimumIntervalBetweenTriggerActionsInSeconds: 0,
      enableLogging: false,
    });

    braze.automaticallyShowInAppMessages();
    braze.changeUser(userId);

    braze.openSession();
  },

  track(name: string, properties?: Record<string, unknown>): void {
    braze.logCustomEvent(name, { ...properties, appVersion: process.env.REACT_APP_VERSION });
  },

  setAvatarImageUrl(url: string): void {
    braze.getUser()?.setCustomUserAttribute("avatarUrl", url);
  },

  subscribeToBanner(placementId: BrazeBannerPlacement, container: HTMLElement | null): string | undefined {
    if (!container || !braze.isInitialized()) return undefined;

    const subscriptionId = braze.subscribeToBannersUpdates(() => {
      const banner = braze.getBanner(placementId);
      const el = container;

      // insertBanner must be called even for control variants to log the impression.
      if (banner) braze.insertBanner(banner, el);

      if (!banner || banner.isControl) {
        el.replaceChildren();
        el.style.display = "none";
        return;
      }

      // Reset the iframe's default 150px height before revealing the container
      // so the layout grows upward rather than shrinking from the browser default.
      const iframe = el.querySelector<HTMLIFrameElement>("iframe");
      if (iframe) iframe.style.height = "0";

      el.style.display = "block";
    });

    braze.requestBannersRefresh([placementId]);

    return subscriptionId;
  },

  unsubscribeBanner(subscriptionId: string | undefined): void {
    if (subscriptionId) {
      braze.removeSubscription(subscriptionId);
    }
  },
};
